import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../auth";
import { Shield, Lock, MapPin, Download, Trash2, LogOut } from "lucide-react";
import { CoupleSection } from "./Couple";

export default function Securite() {
  const [logs, setLogs] = useState([]);
  const { logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    api.get("/securite/connexions").then((r) => setLogs(r.data.logs));
  }, []);

  const exportData = async () => {
    const { data } = await api.get("/securite/export");
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `auprea-export-${new Date().toISOString().slice(0,10)}.json`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const deleteAccount = async () => {
    const confirm1 = window.confirm("Supprimer définitivement votre compte AUPREA ?");
    if (!confirm1) return;
    const t = window.prompt('Tapez "SUPPRIMER" pour confirmer.');
    if (t !== "SUPPRIMER") return;
    await api.delete("/securite/compte");
    await logout();
    nav("/");
  };

  const lockSession = async () => {
    await logout();
    nav("/connexion");
  };

  return (
    <div className="space-y-8">
      <div>
        <div style={{ color: "var(--auprea-gold)", fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
          — Confidentialité & RGPD
        </div>
        <h1 style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }} data-testid="securite-title">Sécurité</h1>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        <StatusCard icon={<Lock />} label="Chiffrement" value="Mots de passe bcrypt" />
        <StatusCard icon={<MapPin />} label="Hébergement" value="Union Européenne" />
        <StatusCard icon={<Shield />} label="Conformité" value="RGPD respecté" />
      </div>

      <CoupleSection />

      <div className="auprea-card">
        <h2 style={{ fontSize: 22, marginBottom: 16 }}>Journal des connexions</h2>
        {logs.length === 0 ? (
          <p style={{ color: "rgba(35,38,46,0.6)" }}>Aucune connexion enregistrée.</p>
        ) : (
          <div className="space-y-2">
            {logs.map((l, i) => (
              <div key={i} className="flex justify-between text-sm py-2 border-b" style={{ borderColor: "rgba(21,41,79,0.08)" }} data-testid={`log-row-${i}`}>
                <span>{new Date(l.created_at).toLocaleString("fr-FR")}</span>
                <span style={{ color: "rgba(35,38,46,0.7)" }}>{l.action}</span>
                <span style={{ color: "rgba(35,38,46,0.5)", fontSize: 12 }}>{l.ip}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="auprea-card">
        <h2 style={{ fontSize: 22, marginBottom: 16 }}>Mes droits RGPD</h2>
        <div className="flex flex-wrap gap-4">
          <button onClick={exportData} className="auprea-btn-outline" data-testid="btn-export">
            <Download size={18} style={{ marginRight: 8 }} /> Exporter mes données
          </button>
          <button onClick={lockSession} className="auprea-btn-outline" data-testid="btn-lock">
            <LogOut size={18} style={{ marginRight: 8 }} /> Verrouiller la session
          </button>
          <button onClick={deleteAccount} className="auprea-btn-outline" style={{ borderColor: "#b53a3a", color: "#b53a3a" }} data-testid="btn-delete-account">
            <Trash2 size={18} style={{ marginRight: 8 }} /> Supprimer mon compte
          </button>
        </div>
      </div>
    </div>
  );
}

function StatusCard({ icon, label, value }) {
  return (
    <div className="auprea-card" style={{ borderColor: "rgba(47,125,91,0.3)", backgroundColor: "rgba(47,125,91,0.05)" }}>
      <div style={{ color: "var(--auprea-green)" }}>{icon}</div>
      <div style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: "0.1em", marginTop: 12, color: "rgba(35,38,46,0.6)" }}>{label}</div>
      <div style={{ fontFamily: "Spectral, serif", fontSize: 18, marginTop: 4, color: "var(--auprea-navy)" }}>{value}</div>
    </div>
  );
}
